import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DIALOG_WIDTH_XL } from '@core/core.tokens';
import { InputJson } from '@core/models/built/session-step-value-json.model';
import { SessionStep } from '@core/models/session.model';
import { TranslocoService } from '@ngneat/transloco';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import it from './i18n/input-object-report.it.json';

@Component({
  templateUrl: './input-object-report.component.html',
  styles: [
    `
    .jsonEditor {
      height: 700px;
    }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputObjectReportComponent implements OnChanges {

  @Input() step!: SessionStep;

  private step$$ = new BehaviorSubject<SessionStep>(this.step);
  step$ = this.step$$.asObservable();

  jsonForm = this.fb.group({ json: [{ value: undefined, disabled: true }] });

  input$ = this.step$.pipe(
    map(step => {
      if (step.values && step.values.length > 0) {
        return JSON.stringify((step.values[0].value as InputJson).input, null, '\t');
      } else {
        return undefined;
      }
    })
  );

  codeEditorOptions = {
    theme: 'vs-dark',
    language: 'json',
    readOnly: true,
    minimap: { enabled: false }
  };

  constructor(
    private fb: FormBuilder,
    private translocoSvc: TranslocoService,
    private dialog: MatDialog,
    @Inject(DIALOG_WIDTH_XL) private dialogWidthXl: string
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

  viewObjectData(codeTmpl: TemplateRef<unknown>, json: unknown) {
    this.jsonForm.setValue({ json });

    this.dialog.open(codeTmpl, { width: this.dialogWidthXl });
  }
}
